import { useTheme } from "@emotion/react";
import { Container, Typography, IconButton, Fade, Paper, alpha } from "@mui/material";
import { Close, SportsGymnastics, FitnessCenter } from "@mui/icons-material";
import React from "react";
import InputSection from "./InputSection";

export default function Searchbar({ open, handleClose }) {
  const theme = useTheme();
  
  return (
    <Fade in={open} timeout={300}>
      <Container
        sx={{
          backdropFilter: "blur(16px)",
          WebkitBackdropFilter: "blur(16px)",
          position: "absolute",
          border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
          borderRadius: "24px",
          p: { xs: "1rem", sm: "1.5rem" },
          top: "calc(100% + 20px)",
          left: "50%",
          transform: "translate(-50% , 0)",
          visibility: open ? "visible" : "hidden",
          opacity: open ? "1" : "0",
          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
          width: { xs: "90%", sm: "80%", md: "70%", lg: "800px" },
          maxWidth: "900px",
          zIndex: 1300,
          bgcolor: alpha(theme.palette.background.paper, 0.55),
          boxShadow: `0 20px 35px -8px ${alpha(theme.palette.common.black, 0.2)}`,
          "&::before": {
            content: '""',
            position: "absolute",
            top: "-8px",
            left: "50%",
            transform: "translateX(-50%) rotate(45deg)",
            width: "16px",
            height: "16px",
            bgcolor: alpha(theme.palette.background.paper, 0.85),
            borderLeft: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
            zIndex: -1,
          },
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: "12px",
            right: "12px",
            color: theme.palette.text.secondary,
            transition: "all 0.2s ease",
            "&:hover": {
              transform: "rotate(90deg) scale(1.1)",
              color: theme.palette.error.main,
              bgcolor: alpha(theme.palette.error.main, 0.1),
            },
          }}
          size="small"
        >
          <Close />
        </IconButton>

        {/* Header with Animation */}
        <Typography
          sx={{
            fontWeight: 800,
            py: "0.75rem",
            mb: "1rem",
            fontSize: { xs: "1.2rem", sm: "1.5rem", md: "1.8rem" },
            color: theme.palette.primary.main,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            flexWrap: "wrap",
          }}
          component={"h1"}
        >
          <FitnessCenter 
            sx={{ 
              fontSize: { xs: "1.5rem", sm: "2rem" },
              animation: open ? "pulse 1.5s ease-in-out infinite" : "none",
              "@keyframes pulse": {
                "0%, 100%": { transform: "scale(1)" },
                "50%": { transform: "scale(1.1)" },
              },
            }} 
          />
          <span>آدین زون</span>
          <Typography
            component={"span"}
            sx={{
              mr: ".5rem",
              background: `linear-gradient(135deg, ${theme.palette.secondary.main}, ${theme.palette.primary.main})`,
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              color: "transparent",
              fontSize: { xs: "1rem", sm: "1.3rem", md: "1.5rem" },
              fontWeight: 600,
            }}
          >
            همراه ورزشی تو !
          </Typography>
          <SportsGymnastics 
            sx={{ 
              fontSize: { xs: "1.5rem", sm: "2rem" },
              animation: open ? "bounce 2s ease-in-out infinite" : "none",
              "@keyframes bounce": {
                "0%, 100%": { transform: "translateY(0)" },
                "50%": { transform: "translateY(-5px)" },
              },
            }} 
          />
        </Typography>

        {/* Decorative Line */}
        <Paper
          elevation={0}
          sx={{
            height: "3px",
            width: "60px",
            margin: "0 auto 1.5rem auto",
            background: `linear-gradient(90deg, transparent, ${theme.palette.primary.main}, ${theme.palette.secondary.main}, transparent)`,
            borderRadius: "3px",
          }}
        />

        {/* Input Section */}
        <InputSection />
      </Container>
    </Fade>
  );
}